import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { markdownToHtml } from '../utils/markdownToHtml';

interface LegalDocProps {
  title: string;
  fileUrl: string;
}

const LegalDoc: React.FC<LegalDocProps> = ({ title, fileUrl }) => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const res = await fetch(fileUrl);
        if (!res.ok) {
          throw new Error('Документ не найден');
        }
        const text = await res.text();
        setContent(markdownToHtml(text));
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Ошибка загрузки');
      } finally {
        setLoading(false);
      }
    };

    fetchDoc();
  }, [fileUrl]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#d4af37', fontSize: isMobile ? '14px' : '18px' }}>
        Загрузка документа...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ff6b6b', fontSize: isMobile ? '14px' : '18px' }}>
        {error}
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      padding: isMobile ? '16px 12px' : '40px 20px',
      maxWidth: '900px',
      margin: '0 auto',
    }}>
      <button
        onClick={() => navigate(-1)}
        style={{
          background: 'none',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          color: '#d4af37',
          padding: isMobile ? '6px 12px' : '8px 16px',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: isMobile ? '12px' : '14px',
          marginBottom: isMobile ? '16px' : '24px',
          transition: 'all 0.3s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'none';
        }}
      >
        ← Назад
      </button>

      <div
        className="article-content"
        dangerouslySetInnerHTML={{ __html: markdownToHtml(content) }}
        style={{
          background: 'rgba(13, 20, 40, 0.85)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(212, 175, 55, 0.12)',
          borderRadius: '24px',
          padding: isMobile ? '20px 16px' : '40px',
          color: '#f0f0f0',
          fontSize: isMobile ? '14px' : '16px',
          lineHeight: 1.9,
          fontFamily: 'var(--font-sans)',
          boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />
      </div>
    </div>
  );
};

export default LegalDoc;
